import { GeometryChangeRetriever } from "./geometryChangeRetriever";
import { ChangeTypes, GeometryChange } from "./types";
import { isPointCoordinates } from "../../../core/geo/assertions";
import { numberComparator } from "../../../core/comparators/numberComparator";
import { Feature, GeometryCollection, Point } from "geojson";
import Logger from "../../../common/util/Logger";

const logger = new Logger("geometryCollectionRetriever");

const getCoordinates = (feature: Feature | undefined) => {
    return ((feature?.geometry as GeometryCollection).geometries[1] as Point)?.coordinates;
};

export const geometryCollectionChangeRetriever: GeometryChangeRetriever = {
    retrieveChange(featureBefore, featureNow): GeometryChange[] {
        const newCoordinates = getCoordinates(featureNow);
        const radiusNow = featureNow.properties?.radius;
        if (featureBefore === undefined || (featureBefore?.geometry as GeometryCollection).geometries.length === 0) {
            logger.info(`inserting circle with radius: ${radiusNow} and center ${newCoordinates}`);
            return [
                {
                    type: ChangeTypes.INSERT_CIRCLE,
                    coordinateChange: {
                        coordinates: newCoordinates,
                    },
                    radius: radiusNow,
                },
            ];
        }
        const oldCoordinates = getCoordinates(featureBefore);

        const isCircle = featureNow.properties?.isCircle;
        const radiusBefore = featureBefore.properties?.radius;

        if (isCircle && radiusBefore && radiusNow && !numberComparator(radiusBefore, radiusNow, 0.000001)) {
            logger.info(`circle radius updated from ${radiusBefore} to ${radiusNow}`);
            return [{ type: ChangeTypes.RADIUS_CHANGED, radius: radiusNow }];
        }

        if (
            isPointCoordinates(oldCoordinates) &&
            isPointCoordinates(newCoordinates) &&
            numberComparator(oldCoordinates[0], newCoordinates[0]) &&
            numberComparator(oldCoordinates[1], newCoordinates[1])
        ) {
            return [{ type: ChangeTypes.NONE }];
        }
        logger.info(`circle coordinates updated from ${oldCoordinates} to ${newCoordinates}`);
        return [
            {
                type: ChangeTypes.MOVE_CIRCLE,
                coordinateChange: {
                    coordinates: newCoordinates,
                },
            },
        ];
    },
};
